export default {
  created() {
    window.addEventListener("resize", this.updateWindowWidth);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    }
  },
  computed: {
    isMobile() {
      return process.env.VUE_APP_IS_MOBILE === "true";
    },
    isMobileScreen() {
      return this.windowWidth < 1024;
    }
  }
};
